import * as React from "react"
import {
  CardSection,
  ThemeCss,
  Heading,
  HeadingProps,
  Text,
  TextProps,
} from "gatsby-interface"

export type SubsectionProps = {
  children: React.ReactNode
}

export function Subsection({ children }: SubsectionProps) {
  return (
    <CardSection
      applyPaddingBottom={false}
      applyPaddingTop={false}
      css={sectionCss}
    >
      {children}
    </CardSection>
  )
}

export function SubsectionHeading({ children, ...rest }: HeadingProps) {
  return (
    <Heading as="h3" tone="DANGER" css={headingCss} {...rest}>
      {children}
    </Heading>
  )
}

export function SubsectionDescription({ children, ...rest }: TextProps) {
  return (
    <Text css={descriptionCss} {...rest}>
      {children}
    </Text>
  )
}

/* styles */

const sectionCss: ThemeCss = theme => ({
  display: `grid`,
  gridTemplateColumns: `1fr auto`,
  borderTop: `1px solid ${theme.colors.standardLine}`,
  paddingTop: theme.space[6],
  columnGap: theme.space[6],
  rowGap: theme.space[4],
  alignItems: `center`,

  [theme.mediaQueries.tablet]: {
    rowGap: 0,
  },
})

const headingCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[3],
  minHeight: theme.space[8],
  display: `flex`,
  alignItems: `center`,

  svg: {
    color: theme.colors.grey[50],
  },
})

const descriptionCss: ThemeCss = theme => ({
  gridColumn: `1 / 3`,

  [theme.mediaQueries.tablet]: {
    gridColumn: `1 / 2`,
  },
})
